module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.5bfeaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/title-banner1-type2.png
// module id = KnFs
// module chunks = 1